/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://bazaxor72vcolk6ekljmrobasq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-2var6mlkdnbnxbfwt4d2cu54s4",
    "aws_cognito_identity_pool_id": "us-east-1:afec9689-7367-41ac-9807-968a649b494b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_bVfgpLzU3",
    "aws_user_pools_web_client_id": "1jr0kc6gmtr2ft6fi0pu5ogqk9",
    "oauth": {},
    "aws_user_files_s3_bucket": "ubnlprvue3b78566394c64916b7e7bccd84acc694155139-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
